// extracted by mini-css-extract-plugin
module.exports = {"label":"label--hNopsX5a4g","disabled":"disabled--PHbIi5seWo","switch":"switch--njMNctL72X"};